import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {Formik,useFormikContext} from "formik";
import s from "./EditBankTemplate.module.css";
import styles from "../../../styles/styles.module.css";
import {Popover} from "antd";
import info from "../../../assets/img/personalAccount/information.svg";
import classnames from "classnames";
import {motion} from "framer-motion";
import {useNavigate} from "react-router-dom";
import TransparentButton from "../../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from "../../../assets/img/personalAccount/back.svg";
import MyBtn from "../../ui/MyBtn/MyBtn";
import CustomDropdown from "../../ui/CustomDropdown/CustomDropdown";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import CustomDropdownForAccounts from "../../ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import MyInput from "../../ui/MyInput/MyInput";
import {
    checkVopStatusThunk, createTemplate, editTemplateThunk, getTemplateByIdThunk
} from "../../../store/reducers/ActionCreators";
import {typesList} from "../../../Constants/StaticData";
import {
    getValidationSchemaForTemplates
} from "../../BankTransferFormPersonal/FormHelpersForTemplates/FormHelpersForTemplates";
import {SwiftCheckerHelper} from "../../BankTransferFormPersonal/FormHelpers/FormHelpers";
import {setDisabled, setIsLoading} from "../../../store/reducers/UserSlice";
import {useSelector} from "react-redux";
import {selectAccountsByFilter} from "../../../store/reducers/TransactionsSlice/selector";
import CustomModal from "../../ui/CustomModal/CustomModal";
import iconSuccess from "../../../assets/img/personalAccount/tick-circle.svg"
import DomesticEur from "../../BankTransferFormPersonal/FieldsForPaymentTypes/DomesticEur";
import InternationalEur from "../../BankTransferFormPersonal/FieldsForPaymentTypes/InternationalEur";
import DomesticGbp from "../../BankTransferFormPersonal/FieldsForPaymentTypes/DomesticGbp";
import InternationalGbp from "../../BankTransferFormPersonal/FieldsForPaymentTypes/InternationalGbp";
import CustomCheckbox from "../../ui/customCheckbox/CustomCheckbox";
import DomesticUsd from "../../BankTransferFormPersonal/FieldsForPaymentTypes/AchUsd";
import {clearFormByChangeType} from "../../../helpers/clearFormHelper";
import AchUsd from "../../BankTransferFormPersonal/FieldsForPaymentTypes/AchUsd";
import SwiftUsd from "../../BankTransferFormPersonal/FieldsForPaymentTypes/SwiftUsd";
import UsdFedwire from "../../BankTransferFormPersonal/FieldsForPaymentTypes/UsdFedwire";
import {vopStatusDataType} from "../../BankTransferFormPersonal/BankTransferFormPersonal";
import iconInfo from "../../../assets/img/personalAccount/info-circle.svg";
import {FormikPersist} from "../../BankTransferFormPersonal/FormHelpers/FormikPersist";
import {ITemplate} from "../../../types/interfaces";
import CurrencyHelper from "../../../helpers/CurrencyHelper";
import {PrepareDataForBankTransaction} from "../../../helpers/prepareDataForTransactions/PrepareDataForTranzactions";

type PropsType = {
    setCurrent?: Dispatch<SetStateAction<number>>
    setTransferData?: Dispatch<SetStateAction<any>>
    id: string | undefined;
    templateName: string,
    setPurpose: Dispatch<SetStateAction<string>>
    setTemplateName: Dispatch<SetStateAction<string>>
    isButtonDisable: boolean
    withdrawalStatus: string
    purpose?: string
}

const AutoSetPaymentTypeHelper: React.FC<{ currency: string, payerAccount?: string}> = ({currency, payerAccount}) => {

    const {setFieldValue} = useFormikContext();

    const stringifiedValue = sessionStorage.getItem('template-form')

    const presavedData = JSON.parse(String(stringifiedValue))

    useEffect(() => {

        if (presavedData?.values?.payerAccount && presavedData?.values?.payerAccount === payerAccount) {
            return
        }

        if (currency === 'GBP') {
            setFieldValue('paymentRegions', '');
        }
        if (currency === 'EUR') {
            setFieldValue('paymentRegions', '');
        }
    }, [currency, setFieldValue]);

    return null;
};

const EditBankTemplate = (props: PropsType) => {
    const navigate = useNavigate()

    const [paymentBankTemplate, setPaymentBankTemplate] = useState<ITemplate>()
    const [paymentRegion, setPaymentRegion] = useState("")
    const [isShowSuccessModal, setIsShowSuccessModal] = useState(false)
    const [isShowPaymentSentSuccessModal, setIsShowPaymentSentSuccessModal] = useState(false)

    const accountsList = useSelector(selectAccountsByFilter)
    const token = useAppSelector(state => state.userReducer.userToken)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const dispatch = useAppDispatch()
    const [isMobile, setIsMobile] = useState(false)
    const [currency, setCurrency] = useState('')
    const [accountNumber, setAccountNumber] = useState('')
    const [localyDisabled, setLocalyDisabled] = useState(false)

    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState<boolean | null>(false)
    const [isErrorPopUpFieldOpen, setIsErrorPopUpFieldOpen] = useState<boolean | null>(false)

    const [isTwoFaCodeValid, setIsTwoFaCodeValid] = useState('')
    const [isIbanWrong, setIsIbanWrong] = useState(false)
    const [selectedOptionRecipientType, setSelectedOptionRecipientType] = useState("INDIVIDUAL")

    const [isThisFirstCheck, setIsThisFirstCheck] = useState<boolean | null>(true)
    const [vopErrorText, setVopErrorText] = useState<string | null>('')
    const [isVopError, setIsVopError] = useState<boolean | null>(false)
    const [isVopSuccess, setIsVopSuccess] = useState<boolean | null>(false)

    useEffect(() => {
        if (!accountNumber) {
            return
        }
        sessionStorage.setItem("accountNumber", accountNumber)
    }, [accountNumber])

    useEffect(() => {
        const accNumber = sessionStorage.getItem("accountNumber")
        if (accNumber) {
            setAccountNumber(accNumber)
        }
    }, [])

    const [paymentRegionOptions, setPaymentRegionOptions] = useState(typesList)

    useEffect(() => {
        if (currency === 'EUR') {
            setPaymentRegionOptions(['SEPA', 'international']);
        } else if (currency !== 'EUR') {
            setPaymentRegionOptions(typesList);
        }
    }, [currency]);

    const clearEmailPin = () => {
        setIsTwoFaCodeValid('')
        setIsErrorPopupOpen(false)
    }

    useEffect(() => {
        dispatch(getTemplateByIdThunk(token, props.id, accountId))
            .then((res) => {
                props.setTemplateName(res?.data?.templateName)
                if (res.data.type === 'Internal') {
                    props.setPurpose('Transfer to a LuxPay User')
                } else {
                    setPaymentBankTemplate(res.data)
                }
            })
        return () => {
            localStorage.removeItem('transfer-form')
        }
    }, [])

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }, [window.innerWidth])

    // domestic USD

    const myInitValues = {
        fullName: paymentBankTemplate?.recipientDetails?.beneficiaryName,
        recipientsIban: paymentBankTemplate?.recipientDetails?.iban || paymentBankTemplate?.recipientDetails?.ibanCode,
        recipientsSwiftBic: paymentBankTemplate?.recipientDetails?.swiftCode,
        recipientsAddress: paymentBankTemplate?.recipientDetails?.beneficiaryAddress,
        recipientsAccountNumber: paymentBankTemplate?.recipientDetails?.beneficiaryAccountNumber,
        sortCode: paymentBankTemplate?.recipientDetails?.beneficiarySortCode,
        paymentRegions: paymentBankTemplate?.paymentType === 'sepa' ? paymentBankTemplate?.paymentType.toUpperCase() : paymentBankTemplate?.paymentType,
        payerAccount: paymentBankTemplate?.fromAccountMainIban,
        hiddenAccountNumberFrom: paymentBankTemplate?.account,
        name: paymentBankTemplate?.recipientDetails.firstName,
        surname: paymentBankTemplate?.recipientDetails.lastName,
        recipientPostCode: paymentBankTemplate?.recipientDetails.recipientPostCode,
        companyName: paymentBankTemplate?.recipientDetails.companyName,
        bankName: paymentBankTemplate?.recipientDetails.bankName,
        bankAddress: paymentBankTemplate?.recipientDetails.bankAddress,
        bankCity: paymentBankTemplate?.recipientDetails.bankCity,
        bankPostCode: paymentBankTemplate?.recipientDetails.bankPostCode,
        bankCountry: paymentBankTemplate?.recipientDetails.bankCountry,
        fedwireRoutingNumber: paymentBankTemplate?.recipientDetails.fedwireRoutingNumber,
        achRoutingNumber: paymentBankTemplate?.recipientDetails.achRoutingNumber,
        invoice: {
            name: '',
            data: ''
        },
        type: 'international',
        recipientCity: paymentBankTemplate?.recipientDetails.beneficiaryCity,
        recipientCountry: paymentBankTemplate?.recipientDetails.beneficiaryCountry,
        amount: '',
        recipientType: paymentBankTemplate?.recipientType || paymentBankTemplate?.recipientDetails?.recipientType || 'INDIVIDUAL',
        reference: paymentBankTemplate?.recipientDetails?.reference,
        templateName: paymentBankTemplate?.templateName
    }

    const closeAndRedirect = () => {
        setIsShowSuccessModal(false)
        setIsShowPaymentSentSuccessModal(false)
        navigate(-1)
    }

    const checkVopStatus = async (data: vopStatusDataType) => {
        return await dispatch(checkVopStatusThunk(token, data))
    }

    const onKeyDownHandler = (e: any) => {

        const allowed = /^[A-Za-z0-9\/\-?:().,'+ ]$/;

        if (e.key.length === 1 && !allowed.test(e.key)) {
            e.preventDefault();
        }
    }

    const sendTemplateData = async (templateData: any) => {

        let preparedData = PrepareDataForBankTransaction(templateData);

        dispatch(editTemplateThunk(token, preparedData, props.id))
            .then((res) => {
                console.log(res)
                if (res === "Updated") {
                    setIsShowSuccessModal(true)
                }
            })
            .catch((e) => {
                setIsErrorPopupOpen(true)
            })
            .finally(() => {
                dispatch(setDisabled(false))
                setLocalyDisabled(false)
            })
    }

    return (
        <div className={s.form_wrapper}>

            <CustomModal isModalOpen={isShowSuccessModal} type="confirm">
                <div className={classnames(styles.modal_content, s.modal_content_center)}>
                    <img src={iconSuccess} alt="" className={styles.popup_icon}/>
                    <div className={styles.popup_title}>
                        Success!
                    </div>
                    <div className={styles.popup_subtitle}>
                        Your template has been edited successfully.
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn title={"Ok"}
                               medium
                               isPersonalAccountBtn
                               onClick={() => closeAndRedirect()}
                        />
                    </div>
                </div>
            </CustomModal>

            <CustomModal isModalOpen={isShowPaymentSentSuccessModal} isNotify>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.success}>Success!</span> Your request has been sent
                        successfully.
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn
                            isPersonalAccountBtn
                            title={"Ok"}
                            onClick={() => closeAndRedirect()}
                        />
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="error" isModalOpen={isErrorPopUpFieldOpen} setIsModalOpen={setIsErrorPopUpFieldOpen}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.error}>Failed!</span> Please fill in all fields and try again
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"}
                               onClick={() => setIsErrorPopUpFieldOpen(false)}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="error" isModalOpen={isErrorPopupOpen} setIsModalOpen={setIsErrorPopupOpen}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span
                            className={styles.error}>Failed!</span> {isTwoFaCodeValid ? "Invalid or expired 2FA code. Please try again" : "Your request was rejected. Please try again."}
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={clearEmailPin}/>
                    </div>
                </div>
            </CustomModal>

            <motion.div
                initial={{opacity: 0, scale: 1}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.5}}
            >
                <Formik
                    initialValues={myInitValues}
                    enableReinitialize
                    validationSchema={getValidationSchemaForTemplates(paymentRegion, currency)}
                    onSubmit={async (values) => {

                        if (isIbanWrong) {
                            return
                        }
                        setLocalyDisabled(true)

                        // dispatch(setDisabled(true))
                        const tempData = {
                            ...values,
                            templateName: props.templateName,
                            transferCurrency: currency,
                            accountId: accountId,
                        }


                        if (isThisFirstCheck && paymentBankTemplate?.paymentType === 'sepa') {
                            dispatch(setIsLoading(true))
                            const res = await checkVopStatus({
                                firstName: values.name,
                                lastName: values.surname,
                                companyName: values.companyName,
                                ibanCode: values.recipientsIban,
                                swiftCode: values.recipientsSwiftBic
                            })

                            if (res.matchedStatus === 'CMTC') {
                                dispatch(setIsLoading(false))
                                setLocalyDisabled(false)
                                setIsVopError(true)
                                setVopErrorText(`The payee name partially matches the account holder details.
                                    Please review the payee information before proceeding.`)
                                return
                            } else if (res.matchedStatus === 'NMTC') {
                                dispatch(setIsLoading(false))
                                setLocalyDisabled(false)
                                setIsVopError(true)
                                setVopErrorText(`The payee name does not match the account holder details.
                                    Proceeding may result in funds being sent to an unintended recipient.`)
                                return
                            } else if (res.matchedStatus === 'NOAP') {
                                dispatch(setIsLoading(false))
                                setLocalyDisabled(false)
                                setIsVopError(true)
                                setVopErrorText(`The payee details could not be verified at this time.
                                    Proceeding may result in funds being sent to an unintended recipient.`)
                                return
                            } else if (res?.response?.status === 500) {
                                dispatch(setIsLoading(false))
                                setLocalyDisabled(false)
                                setIsVopError(true)
                                setVopErrorText(`Recipient name or surname does not match with Iban owner data. Do you want to continue?`)
                                return
                            } else if (res?.response?.data === "API Vop validation failed") {
                                dispatch(setIsLoading(false))
                                setLocalyDisabled(false)
                                setIsVopError(true)
                                setVopErrorText(`The payee details could not be verified at this time.
                                    Proceeding may result in funds being sent to an unintended recipient.`)
                                return
                            } else if (res?.matchedStatus === "MTCH") {
                                dispatch(setIsLoading(false))
                                setIsVopSuccess(true)
                                return
                            }

                            setIsThisFirstCheck(false)
                            dispatch(setIsLoading(false))

                        }

                        const secondTempData = {
                            ...tempData,
                            hiddenAccountNumberFrom: paymentBankTemplate?.account,
                        }

                        await sendTemplateData(secondTempData)

                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleSubmit,
                          setFieldValue,
                          setValues
                      }) =>

                        (
                            <form onSubmit={handleSubmit}>

                                <CustomModal type="confirm" isNotify isModalOpen={isVopSuccess}
                                             setIsModalOpen={setIsVopSuccess}>
                                    <div className={s.modal_content}>
                                        <div className={styles.popup_subtitle}>
                                            <span className={styles.success}>Success!</span> Verification of payee passed successfully
                                        </div>
                                        <div className={s.popup_button_block}>
                                            <MyBtn isPersonalAccountBtn title={"Ok"}
                                                   onClick={() => {
                                                       setIsVopSuccess(false)
                                                       setIsThisFirstCheck(false)
                                                       handleSubmit()
                                                   }}
                                            />
                                        </div>
                                    </div>
                                </CustomModal>

                                <CustomModal type="info" isModalOpen={isVopError}
                                             setIsModalOpen={setIsVopError}>
                                    <div className={styles.popup_content}>
                                        <img src={iconInfo} alt="" className={styles.img_block}/>
                                        <div className={styles.popup_title}>
                                            Attention
                                        </div>
                                        <div className={styles.popup_subtitle}>
                                            {vopErrorText}
                                        </div>
                                        <div className={styles.popup_button_wrapper}>
                                            <div className={styles.button_full_width}>
                                                <TransparentButton
                                                    title={"Cancel"}
                                                    isPersonalAccountBtn
                                                    buttonType={"info"}
                                                    medium
                                                    onClick={() => setIsVopError(false)}
                                                />
                                            </div>
                                            <div className={styles.button_full_width}>
                                                <MyBtn
                                                    title={"Confirm"}
                                                    isPersonalAccountBtn
                                                    buttonType={"info"}
                                                    onClick={() => {
                                                        setIsThisFirstCheck(false)
                                                        setIsVopError(false)
                                                        handleSubmit()
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </CustomModal>

                                <div className={s.row}>

                                    <div className={s.input_block}>
                                        <div className={s.input_label}>
                                            <span><span className={s.red}>*</span> Payer account</span>
                                            <Popover
                                                content={"Please select the account you wish to make a transfer from."}
                                                color={'#EEEFEF'}
                                                overlayInnerStyle={{
                                                    fontFamily: 'Manrope',
                                                    width: '280px',
                                                    padding: '13px 16px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#E7F0EC'
                                                }}
                                            >
                                                <img src={info} alt=""/>
                                            </Popover>
                                        </div>
                                        <CustomDropdownForAccounts
                                            items={accountsList}
                                            placeholder={"Please select the account"}
                                            id="payerAccount"
                                            name="payerAccount"
                                            isError={errors.payerAccount}
                                            touched={touched.payerAccount}
                                            setAccountNumber={setAccountNumber}
                                            disabled={false}
                                            setCurrency={(selectedCurrency) => {
                                                setCurrency(selectedCurrency);
                                            }}
                                        />
                                        {errors.payerAccount && touched.payerAccount &&
                                            <div className={s.error_message}>{errors.payerAccount as string}</div>}
                                    </div>

                                    <div className={s.input_block}>
                                        <div className={s.input_label}>
                                            <span><span className={s.red}>*</span> Payment type </span>
                                        </div>
                                        <CustomDropdown
                                            customId="paymentRegions"
                                            items={paymentRegionOptions}
                                            placeholder={"Please select the payment type"}
                                            id="paymentRegions"
                                            name="paymentRegions"
                                            isError={errors.paymentRegions}
                                            touched={touched.paymentRegions}
                                            setItem={(value: any) => {
                                                clearFormByChangeType(values, setValues, ["payerAccount", "recipientType", "type"])
                                                setPaymentRegion(value);
                                                setFieldValue('paymentRegions', value);
                                            }}
                                            disable={!values.payerAccount}
                                        />
                                        {errors.paymentRegions && touched.paymentRegions &&
                                            <div className={s.error_message}>{errors.paymentRegions as string}</div>}
                                    </div>

                                </div>

                                {
                                    values.paymentRegions !== "" && currency !== "" &&
                                    <div>
                                        <div className={classnames(s.input_block, s.recipient_type_block)}>
                                            <div className={s.input_label}>
                                                <span>RECIPIENT TYPE</span>
                                            </div>
                                            <div className={s.flex_label}>
                                                <label className={s.flex_label}>
                                                    <CustomCheckbox
                                                        handleChange={() => {

                                                            clearFormByChangeType(values, setValues, ["payerAccount", "paymentRegions", "recipientType", "type"])

                                                            setSelectedOptionRecipientType(
                                                                "INDIVIDUAL"
                                                            );
                                                            setFieldValue(
                                                                "companyName",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                "recipientType",
                                                                "INDIVIDUAL"
                                                            );
                                                        }}
                                                        id="INDIVIDUAL"
                                                        name="INDIVIDUAL"
                                                        isChecked={values.recipientType === "INDIVIDUAL"}
                                                    />
                                                    <span
                                                        className={
                                                            values.recipientType ===
                                                            "INDIVIDUAL"
                                                                ? s.type_of_payment_active
                                                                : s.type_of_payment_inactive
                                                        }
                                                    >
                                                        INDIVIDUAL
                                                    </span>
                                                </label>
                                                <label className={s.flex_label}>
                                                    <CustomCheckbox
                                                        handleChange={() => {

                                                            clearFormByChangeType(values, setValues, ["payerAccount", "paymentRegions", "recipientType", "type"])

                                                            setSelectedOptionRecipientType(
                                                                "BUSINESS"
                                                            );
                                                            setFieldValue(
                                                                "name",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                "surname",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                "recipientType",
                                                                "BUSINESS"
                                                            );
                                                        }}
                                                        id="BUSINESS"
                                                        name="BUSINESS"
                                                        isChecked={
                                                            values.recipientType ===
                                                            "BUSINESS"
                                                        }
                                                    />
                                                    <span
                                                        className={
                                                            values.recipientType ===
                                                            "BUSINESS"
                                                                ? s.type_of_payment_active
                                                                : s.type_of_payment_inactive
                                                        }
                                                    >
                                                        BUSINESS
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                }

                                {/*SEPA (for EUR)*/}
                                {
                                    values.paymentRegions === "SEPA" && currency === "EUR" &&
                                    <DomesticEur
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                        disabled={false}
                                        isTemplateCreation={true}
                                        onKeyDown={onKeyDownHandler}
                                    />
                                }

                                {/*International (for EUR)*/}
                                {
                                    values.paymentRegions === "international" && currency === "EUR" &&
                                    <InternationalEur
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        disabled={false}
                                        isIbanWrong={isIbanWrong}
                                        isTemplateCreation={true}
                                        onKeyDown={onKeyDownHandler}
                                    />
                                }

                                {/*Domestic (for GBP)*/}
                                {
                                    values.paymentRegions === "domestic" && currency === "GBP" &&
                                    <DomesticGbp
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        disabled={false}
                                        isIbanWrong={isIbanWrong}
                                        isTemplateCreation={true}
                                    />
                                }

                                {/*International (for GBP)*/}
                                {
                                    values.paymentRegions === "international" && currency === "GBP" &&
                                    <InternationalGbp
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        disabled={false}
                                        isIbanWrong={isIbanWrong}
                                        isTemplateCreation={true}
                                    />
                                }

                                {/*domestic (for USD)*/}
                                {
                                    values.paymentRegions === "domestic" && currency === "USD" &&
                                    <DomesticUsd
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        disabled={false}
                                        isIbanWrong={isIbanWrong}
                                    />
                                }

                                {/*ACH (for USD)*/}
                                {
                                    values.paymentRegions === "ACH" && currency === "USD" &&
                                    <AchUsd
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                    />
                                }

                                {/*SWIFT (for USD)*/}
                                {
                                    values.paymentRegions === "SWIFT" && currency === "USD" &&
                                    <SwiftUsd
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                    />
                                }

                                {/*Fedwire (for USD)*/}
                                {
                                    values.paymentRegions === "Fedwire" && currency === "USD" &&
                                    <UsdFedwire
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                    />
                                }

                                <div className={s.row}>
                                    <div className={s.mobile_row}>
                                        <div className={s.languages_dropdown}>
                                            <MyInput
                                                id="transferCurrency"
                                                name="transferCurrency"
                                                value={currency}
                                            />
                                        </div>

                                        <div className={classnames(s.input_block, s.short)}>

                                        </div>

                                    </div>
                                </div>

                                <div className={s.continue_block}>
                                    <div className={s.required}>
                                        <div>
                                            <span><span className={s.red}>*</span> required fields.</span>
                                        </div>
                                    </div>
                                </div>

                                <div className={s.buttonsWrapper}>
                                    <div className={s.button_block}>
                                        <TransparentButton title={'Back'}
                                                           isPersonalAccountBtn
                                                           large
                                                           icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                                           onClick={() => {
                                                               navigate(-1);
                                                           }}/>
                                    </div>

                                    <MyBtn title={'Save'}
                                           large
                                           localDisable={localyDisabled}
                                           style={{width: isMobile ? '100%' : 180}}
                                           type="submit"
                                           isPersonalAccountBtn
                                           onClick={() => {
                                               handleSubmit();
                                           }}
                                    />
                                </div>

                                <FormikPersist name="template-form"
                                               setSelectedOptionRecipientType={setSelectedOptionRecipientType}/>

                                <CurrencyHelper
                                    accountsList={accountsList}
                                    payerAccount={values.payerAccount}
                                    hiddenAccountNumberFrom={values.hiddenAccountNumberFrom}
                                    setCurrency={setCurrency}
                                />

                                <SwiftCheckerHelper
                                    setFieldValue={setFieldValue}
                                    setIsIbanWrong={setIsIbanWrong}
                                    isAdditionalFields
                                    currency={currency}
                                />

                                <AutoSetPaymentTypeHelper currency={currency} payerAccount={values.payerAccount}/>

                            </form>
                        )}
                </Formik>
            </motion.div>
        </div>
    );
};

export default EditBankTemplate;
